var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreasureMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18.334,
    viewBox: "0 0 20 18.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "treasure-map-21",
    transform: "translate(0 -0.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(0 0.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M19.679,1.177a.83.83,0,0,0-.715-.152L12.533,2.633,7.763,1.042A.821.821,0,0,0,7.3,1.025L.631,2.692A.833.833,0,0,0,0,3.5v15a.833.833,0,0,0,1.036.808L7.467,17.7l4.77,1.59a.836.836,0,0,0,.466.017l6.667-1.667A.831.831,0,0,0,20,16.833v-15A.832.832,0,0,0,19.679,1.177ZM5.833,11h-2.5V9.333h2.5ZM10,11H7.5V9.333H10Zm7.012.833-1.178,1.178-1.667-1.667L12.5,13.012l-1.178-1.178,1.667-1.667L11.322,8.5,12.5,7.322l1.667,1.667,1.667-1.667L17.012,8.5l-1.667,1.667Z",
    transform: "translate(0 -0.999)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreasureMap);
export default __webpack_public_path__ + "static/media/treasure-map.c5964080d757571389d18203d81761ed.svg";
export { ForwardRef as ReactComponent };